module.exports = __webpack_public_path__ + "img/header-navigation-below-nissan.a1494687.png";